import { FC, useCallback } from 'react';
import { useMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { Form, Formik } from 'formik';

import SaveIcon from '@mui/icons-material/Save';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from '@mui/material/Stack';
import TextField from 'components/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from 'components/Checkbox';

import { useErrorHandler } from 'lib';
import { useDialog } from 'components/Dialog';

type FormFields = {
  name: string;
  etgKey: string;
  displayInSearch: boolean;
};

type Props = {
  connectionID: string;
};

const initial = {
  name: '',
  etgKey: '',
  displayInSearch: true,
};

const CateringOptionsListAdd: FC<Props> = ({ connectionID }) => {
  const { close } = useDialog();
  const errorHandler = useErrorHandler();

  const [add, loading] = useMutation(graphql`
    mutation CateringOptionsListAddMutation(
      $input: CreateCateringOptionInput!
      $connections: [ID!]!
    ) {
      createCateringOption(input: $input) {
        node
          @appendNode(
            connections: $connections
            edgeTypeName: "CateringOptionEdge"
          ) {
          ...CateringOptionsListRow_cateringOption
        }
      }
    }
  `);

  const handleSubmit = useCallback(
    (input: FormFields) => {
      add({
        variables: { connections: [connectionID], input },
        ...errorHandler({
          onCompleted: () => {
            close();
          },
        }),
      });
    },
    [add, close, connectionID, errorHandler]
  );

  return (
    <Formik<FormFields> initialValues={initial} onSubmit={handleSubmit}>
      <Form>
        <DialogTitle>Naujas maitinimo pasirinkimas</DialogTitle>

        <DialogContent dividers>
          <DialogContentText sx={{ mb: 2 }}>
            Kažkoks tekstas aprašantis ką mes čia pridedame
          </DialogContentText>

          <Stack spacing={4}>
            <TextField autoFocus name="name" label="Pavadinimas" fullWidth />

            <TextField name="etgKey" label="ETG ID" fullWidth />

            <FormControlLabel
              control={<Checkbox name="displayInSearch" />}
              label="Rodyti paieškoje"
            />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={close} variant="text">
            Atšaukti
          </Button>

          <LoadingButton
            loading={loading}
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}>
            Saugoti
          </LoadingButton>
        </DialogActions>
      </Form>
    </Formik>
  );
};

export default CateringOptionsListAdd;
